import { useLayoutEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import commonNetwork from '../../../common/api/commonNetwork';
import { useRecoilValue } from 'recoil';
import { tenantState } from '../../../store/recoil/tenant/atoms';
import Loading from '../../components/Loading';
import { getNavigationUrl } from '../../../common/helpers/navigationHelpers';




const Error404 = () => {

  const navigate = useNavigate();
  const [loadingVisible, setLoadingVisible] = useState(true);
  const { firmname } = useParams();
  const { isfirmAvailable,  isFetching} = useRecoilValue(tenantState);

  useLayoutEffect(()=>{
    if (!isFetching) {
      isFirmCheck();
    }


  },[isFetching]);

  const isFirmCheck = async () => {

 
    if (firmname && firmname != "404") {
      const result = await commonNetwork.checkToken(true);
      if (isfirmAvailable) {
        if (result) {
          navigate(getNavigationUrl("/dashboard"));
        } else {
          navigate(getNavigationUrl("/login"));
        }
      }
     
    }

    setLoadingVisible(false);
  }


  if (loadingVisible) {
    return <Loading />
  }

  return (
    <>
      <div className="bg-gradient-to-r from-rose-100 to-teal-100 dark:from-gray-700 dark:via-gray-900 dark:to-black">
        <div className="h-screen w-screen flex justify-center items-center">
          <div className="flex flex-col justify-center text-center gap-6">

            {firmname && firmname?.length > 0 ? (
              <Link to={"/" + firmname + "/dashboard"} className="flex justify-center mx-auto">
                <img className="h-6 block dark:hidden" src={"/images/logoNew.png"} alt="" />
              </Link>) : (
              <div className='flex justify-center mx-auto'>
                <img className="h-6 block dark:hidden" src={"/images/logoNew.png"} alt="" />
              </div>
            )}
            <p className="text-3xl font-semibold text-primary">404!</p>
            <h1 className="text-4xl font-bold tracking-tight dark:text-gray-100">Sayfa Bulunamadı.</h1>
            <p className="text-base text-gray-600 dark:text-gray-300">Üzgünüz, Aradığınız içerik bulunamadı.</p>
            {firmname && firmname?.length > 0 && (
              <Link to={"/" + firmname + "/dashboard"} className="text-base font-medium text-primary"> Ana sayfaya Dön </Link>
            )}

          </div>
        </div>
      </div>
    </>
  )
};

export default Error404